module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/GVKCGh/tc-custom/9781423658801.jpg?1737126688759",
      "alt": "This image is the cover for the book Bears: The Mighty Grizzlies of the West"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bears: The Mighty Grizzlies of the West\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The mighty North American brown bear, most often referred to as the grizzly, is an iconic symbol of power and strength. Mostly found in the Western United States and Canada, the still-endangered bruin has made strides into a tenuous sustainability. The strikingly beautiful photography, and the essay woven through the pages of Bears: The Mighty Grizzlies of the West, showcases this beautiful, smart, and incredible species. Julie Argyle explores their behavior, their family dynamics, and what it means to be a grizzly in the wilderness of the greater Yellowstone area. She includes stories about individual bears: Raspberry and Snow, The Beryl Sow, The Obsidian Sow, Snaggletooth, and 791 (a famous boar), and looks at the issues of increasing conflicts between humans and the grizzlies and what the future holds for them.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Julie Argyle\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0